import * as types from "./actionTypes"

let getProducts = (x) => (dispatch) => {

    dispatch({ type: types.GET_PRODUCTS_REQUEST })
    let url
    console.log(x)
    if(x===undefined){
        url=`https://fakestoreapi.com/products`
        console.log(url)
    }
   else if(x!==8&&x!==undefined){
        url=`https://fakestoreapi.com/products/${x}`
        console.log(url)
    }else  if(x==8){
        url=`https://fakestoreapi.com/products?limit=${x}`
        console.log(url)
    }
   
    fetch(url, {
        method: "GET",

    }).then((res) => res.json()).then((res) => {
    
        dispatch({ type: types.GET_PRODUCTS_SUCCESS, payload: res })

    }).catch((err) => {
        console.log(err)
        dispatch({ type: types.GET_PRODUCTS_FAILE })

    })
}
let addToCart=(data)=>(dispatch)=>{

    dispatch({ type: types.POST_CART_REQUEST})
     
    fetch(`https://first-deploy-92k2.onrender.com/addcart`, {
        method: "POST",
        body:JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
          },

    }).then((res) => res.json()).then((res) => {
        dispatch(GetCart())
         
        // dispatch({ type: types.POST_CART_SUCCESS, payload: res })
  

    }).catch((err) => {
        console.log(err)
        dispatch({ type: types.POST_CART_FAILE })

    })
}
let GetCart=()=>(dispatch)=>{

    dispatch({ type: types.GET_CART_REQUEST})

    fetch(`https://first-deploy-92k2.onrender.com/cart`, {
        method: "GET",

    }).then((res) => res.json()).then((res) => {
      
        dispatch({ type: types.GET_CART_SUCCESS, payload: res.msg})

    }).catch((err) => {
        console.log(err)
        dispatch({ type: types.GET_CART_FAILE })

    })
}

let CartQuantity=(data)=>(dispatch)=>{

    dispatch({ type: types.PATCH_CARTQUANTITY_REQUEST})
   
   return  fetch(`https://first-deploy-92k2.onrender.com/editcart/${data._id}`, {
        method: "PATCH",
        body:JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
          },

    }).then((res) => res.json()).then((res) => {
          dispatch(GetCart())
          
        // dispatch({ type: types.PATCH_CARTQUANTITY_SUCCESS, payload: res })
          
    }).catch((err) => {
        console.log(err)
        dispatch({ type: types.PATCH_CARTQUANTITY_FAILE })

    })

}
let deleteCart=(data)=>(dispatch)=>{

    dispatch({ type: types.DELETE_CART_REQUEST})
 
    fetch(`https://first-deploy-92k2.onrender.com/deletecart/${data._id}`, {
        method: "DELETE",
        }).then((res) => res.json()).then((res) => {
            dispatch(GetCart())
         
        // dispatch({ type: types.DELETE_CART_SUCCESS, payload: res })

    }).catch((err) => {
        console.log(err)
        dispatch({ type: types.DELETE_CART_FAILE })

    })
}
export { getProducts,addToCart ,GetCart,CartQuantity,deleteCart}